import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'icon-menu',
  templateUrl: './icon-menu.component.html',
  styleUrls: ['./icon-menu.component.scss'],
})
export class IconMenuComponent  implements OnInit {
  @Input() size :number = 20;
  constructor() { }

  ngOnInit() {}

}
